import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/data/mockData";

export default function FAQPage() {
  return (
    <div>
      <section className="bg-[#0A2540] text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm font-semibold tracking-wide uppercase text-orange-400 mb-3">FAQ</div>
          <h1 className="text-4xl lg:text-5xl font-display font-extrabold">Frequently asked questions</h1>
          <p className="mt-3 text-lg text-slate-300 max-w-2xl">Can't find what you're looking for? Give us a call on (03) 5941 5070.</p>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 py-16">
        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {FAQ_ITEMS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="bg-white border border-slate-200 rounded-lg px-5">
              <AccordionTrigger className="text-left font-semibold text-[#0A2540] hover:no-underline py-5" data-testid={`faq-q-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
    </div>
  );
}
